import { render, staticRenderFns } from "./ImportView.vue?vue&type=template&id=5d01ba2d"
import script from "./ImportView.vue?vue&type=script&lang=js"
export * from "./ImportView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports